import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import "./ProfileSettings.scss"

const ProfileSettings = ({ 
    showProfileSettings,
    onLogOutHandler
 }) => {

    const navigate = useNavigate();

    return (
        <div className={!showProfileSettings ? 'profile-settings__hidden' : 'profile-settings'}>
             <button className='profile-settings__btn profile-settings__btn_exit' onClick={e => onLogOutHandler(e)}>Выход</button>
        </div>
    )
}

export { ProfileSettings }